/** =========================================================
 * Module: input-date-time-picker.directive.js
 * Bootstrap input-date-time-picker input
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('inputDateTimePicker', inputDateTimePicker);

  inputDateTimePicker.$inject = ['$rootScope', '$translate'];

  function inputDateTimePicker($rootScope, $translate) {
    var directive = {
      restrict: 'E',
      link: link,
      scope: {
        ngModel: '=',
        ngRequired: '=',
        ngChange: '&',
        onlyDate: '='
      },
      template: '<div class="input-group" datetimepicker ng-model="ngInnerModel" ng-required="ngRequired" on-change="valueSet()" options="options" placeholder="{{ format | uppercase }}"><input class="form-control"/><span class="input-group-addon"><span class="{{ icon }}"></span></span></div>'
    };

    return directive;

    function link($scope) {
      $scope.icon = $scope.onlyDate ? 'icon-calendar' : 'icon-clock';
      $scope.format = $scope.onlyDate ? $rootScope.appConfig.dateFormat : $rootScope.appConfig.dateTimeFormat;
      $scope.setValueFormat = $scope.onlyDate ? $rootScope.appConfig.dateFormat : ($rootScope.appConfig.dateTimeFormat  + ':00');
      $scope.ngInnerModel = angular.copy($scope.ngModel);
      $scope.options = {
        format: $scope.format,
        useStrict: true,
        locale: $translate.use(),
        icons: {
          time: 'icon-clock',
          date: 'icon-calendar',
          up: 'icon-arrow-up',
          down: 'icon-arrow-down',
          previous: 'icon-arrow-left',
          next: 'icon-arrow-right',
          today: 'icon-size-actual',
          clear: 'icon-reload',
          close: 'icon-close'
        }
      };

      $scope.valueSet = function () {
        try {
          $scope.ngModel = moment.isMoment($scope.ngInnerModel) ? $scope.ngInnerModel.format($scope.setValueFormat) : $scope.ngInnerModel;
          $scope.ngChange();
        } catch (error) {
          Raven.captureException(error);
        }
      };

      $scope.$watch('ngModel', function (value) {
        if (value) {
          $scope.ngInnerModel = angular.copy(value);
        }
      });
    }
  }
})();
